import React from 'react'
import PropTypes from 'prop-types'

const Add = ({ width = 24, height = 24, fill, onClick, className }) => (
  <div
    className={`p-3 cursor-pointer bg-pink-400 rounded-full ${className}`}
    onClick={onClick}
  >
    <svg
      width={width}
      height={height}
      fill={fill ? fill : 'white'}
      viewBox="0 0 40 40"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="m37.2083333 16.625h-15.8333333v-15.83333333c0-.43739584-.3542708-.79166667-.7916667-.79166667h-3.1666666c-.4373959 0-.7916667.35427083-.7916667.79166667v15.83333333h-15.83333333c-.43739584 0-.79166667.3542708-.79166667.7916667v3.1666666c0 .4373959.35427083.7916667.79166667.7916667h15.83333333v15.8333333c0 .4373959.3542708.7916667.7916667.7916667h3.1666666c.4373959 0 .7916667-.3542708.7916667-.7916667v-15.8333333h15.8333333c.4373959 0 .7916667-.3542708.7916667-.7916667v-3.1666666c0-.4373959-.3542708-.7916667-.7916667-.7916667z"
        transform="translate(1 1)"
      />
    </svg>
  </div>
)

Add.propTypes = {
  width: PropTypes.number,
  height: PropTypes.number,
  fill: PropTypes.string,
  onClick: PropTypes.func,
  className: PropTypes.string,
}

export default Add
